const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Footer/LanguageSelector.tsx';
import * as React from 'react';
import { useMemo } from 'react';
import { css } from '@emotion/css';
import { languageMap } from 'App/defs/setupDefs';
import { useDispatch, useSelector } from 'react-redux';
import { selLocale } from '@cistec/common_web/selectors/i18nSelectors';
import { useTheme } from '@mui/material/styles';
import { actionSetI18nLocale } from '@cistec/common_web/actions/intlActions';
import { MenuItem, Select } from '@mui/material';
import { getConfiguration } from 'App/utils/clientSetupGetRessource';

const useClassName = () => {
    const theme = useTheme();
    return useMemo(
        () => css`
            margin-right: ${theme.spacing(2)};
        `,
        [theme]
    );
};

export const LanguageSelector = (props: {}) => {
    const locale = useSelector(selLocale);
    const dispatch = useDispatch();
    const className = useClassName();

    const configuration = getConfiguration();
    const { languages } = configuration;

    const handleChange = (event: any) => {
        dispatch(actionSetI18nLocale(event.target.value));
    };

    return (
        <Select value={locale} onChange={handleChange} className={className}>
            {languages.map(languageCode => (
                <MenuItem value={languageCode} key={languageCode}>
                    {languageMap[languageCode]}
                </MenuItem>
            ))}
        </Select>
    );
};

export default LanguageSelector;
